import { initializeChakraComponent } from 'Shared/chakra-initialize';
import { withBreakpointsContext } from 'Shared/utils/breakpoints';
import { goToEditPage } from 'Guide/go_to_wiki_edit_page';
import { WikiSearch, HitType } from 'Guide/wiki_search';
import { _js } from '@ifixit/localize';

function NewPageWikiSearch({
   namespace,
   placeHolder,
   createType,
}: {
   namespace: string;
   placeHolder: string;
   createType?: string;
}) {
   return (
      <WikiSearch
         inputClassName={'title-input-' + (createType || namespace)}
         namespace={namespace}
         placeHolder={placeHolder}
         buttonText={_js('Create')}
         // @ts-expect-error TS(2322) FIXME: Type '({ query, namespace }: { query: string; name... Remove this comment to see the full error message
         onNewDeviceSelected={goToEditPageOnClick}
         onKnownDeviceSelected={createType === 'guide' ? goToEditPageOnDropdownClick : goToViewPage}
         createType={createType}
      />
   );
}

function goToViewPage({ selectedItem }: { selectedItem: HitType }): void {
   const url = selectedItem.url;
   window.location.href = url;
}

function goToEditPageOnClick({ query, namespace }: { query: string; namespace: string }): void {
   if (!query || query.length === 0) {
      // @ts-expect-error TS(2322) FIXME: Type 'null' is not assignable to type 'void'.
      return null;
   }

   goToEditPage(namespace, query);
}

function goToEditPageOnDropdownClick({
   selectedItem,
   createType,
}: {
   selectedItem: HitType;
   createType: string;
}): void {
   const title = selectedItem.device;
   goToEditPage(createType, title);
}

initializeChakraComponent('NewPageWikiSearch', withBreakpointsContext(NewPageWikiSearch));
